export const countRemainingTimeForShipping = (revisionDeadline = '') => {
  const date = new Date()
  const currentTime = date.getTime()
  const closeDate = revisionDeadline ? revisionDeadline : date.toDateString() + ' 15:00:00 GMT+9'
  const closeTime = new Date(closeDate).getTime()

  let milliseconds

  if (currentTime >= closeTime) {
    milliseconds = closeTime - currentTime + 86400 * 1000
  } else {
    milliseconds = closeTime - currentTime
  }

  const hours = Math.floor(milliseconds / 3600 / 1000)
  const dayLeft = Math.floor(hours / 24)
  const hourLeft = hours % 24
  const minutes = Math.floor((milliseconds - hours * 3600 * 1000) / (1000 * 60))

  const dayString = dayLeft !== 0 && revisionDeadline !== '' ? dayLeft + '日' : ''
  const hourString = hourLeft !== 0 ? hourLeft + '時間' : ''
  const minString = minutes !== 0 ? minutes + '分以内' : ''
  return dayString + hourString + minString
}

export const formatOneDecimal = (inputPrice?: string | number) => {
  if (!inputPrice) return inputPrice
  const matchedDecimal = inputPrice.toString().match(/^-?\d+(?:\.\d{0,1})?/)
  const decimalVal = matchedDecimal ? matchedDecimal[0] : '0'
  return decimalVal.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export const formatSliceYear = (inputDate?: string) => {
  if (!inputDate) return inputDate
  return inputDate.substring(5)
}

export const normalizeNumber = (input: string) => {
  const normalize = input.replace(/[\uFF10-\uFF19]/g, function(value: any) {
    return String.fromCharCode(value.charCodeAt(0) - 0xfee0)
  })
  return Number(normalize)
}

export async function hashEmail(email: string): Promise<string> {
  // Encode the email to a Uint8Array
  const encoder = new TextEncoder()
  const data = encoder.encode(email)

  // Hash the data using SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)

  // Convert the ArrayBuffer to a hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}
